var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.issuer && _vm.newsContent
    ? _c(
        "div",
        {
          staticClass: "tls-news-banner",
          style: { backgroundColor: _vm.newsBackgroundColor },
          attrs: { id: "tls-news-banner" }
        },
        [
          _c("div", {
            directives: [
              {
                name: "dompurify-html",
                rawName: "v-dompurify-html",
                value: _vm.newsContent,
                expression: "newsContent"
              }
            ],
            staticClass: "tls-simple-text -color-white"
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }